
import { z } from "zod";

// Form schema definition
export const bookingSchema = z.object({
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(9, "Please enter a valid phone number"),
  createAccount: z.boolean().default(false),
  password: z.string().optional(),
  confirmPassword: z.string().optional(),
  useSubscription: z.string().optional(),
  isGroupBooking: z.boolean().default(false),
  groupSize: z.number().min(1).default(1),
  groupNames: z.array(z.string()).optional(),
  useGiftCard: z.boolean().default(false),
  giftCardCode: z.string().optional(),
});

// Type for form values
export type FormValues = z.infer<typeof bookingSchema>;
